import { useState } from 'react'

import { Code, type ConnectError } from '@connectrpc/connect'

/**
 * 詳細画面の初回取得失敗の判定 (AC-PPD-001a、版の詳細と提出記録の無い計画の詳細で共通)。
 *
 * - `hasFailed`: 成功データが無いまま失敗したことがある。React Query は refetch 開始時に
 *   status を 'error' → 'pending' へ、error を null にリセットするため、`isError` だけでは
 *   refetch 中に false へ落ちてロゴ表示に切り替わってしまう。`errorUpdatedAt` は過去の失敗
 *   タイムスタンプが残るため、refetch 中も過去に失敗した事実を検出できる (成功後は data が
 *   入り、false に戻る)
 * - `isNotFound`: 直近の失敗が NotFound か。refetch 中は error が null に戻るので、
 *   直近の error.code を state に保持して文言 (NotFound vs 通信・サーバーエラー) の
 *   flicker を防ぐ
 */
export function useDetailFetchFailure(query: {
  data: unknown
  error: ConnectError | null
  errorUpdatedAt: number
}): { hasFailed: boolean; isNotFound: boolean } {
  const { data, error, errorUpdatedAt } = query
  const [lastErrorCode, setLastErrorCode] = useState<Code | null>(null)
  if (error !== null && error.code !== lastErrorCode) {
    setLastErrorCode(error.code)
  } else if (data !== undefined && lastErrorCode !== null) {
    setLastErrorCode(null)
  }
  return {
    hasFailed: data === undefined && errorUpdatedAt > 0,
    isNotFound: lastErrorCode === Code.NotFound,
  }
}
